import React from "react"

// Define the props interface for TypeScript (optional)
interface H5Props {
  label: string
  size?: number // Optional prop for custom font size
  color?: string // Optional prop for custom text color
  font?: string // Optional prop for custom font family
}

const NameLabel: React.FC<H5Props> = ({ label, size, color, font }) => {
  // Define inline styles based on props
  const styles = {
    fontSize: `${size}px` || "1.25rem", // Default Bootstrap h5 font size
    color: color || "inherit", // Default color
    fontFamily: font || "inherit", // Default font
    // backgroundColor: "white",
    // padding: "5px",
  }

  return (
    <h5 className="mb-0" style={styles}>
      {label}
    </h5>
  )
}

export default NameLabel
